<template>
    <div class="form-group">
        <label :for="name">{{ label }}</label>
        <multiselect
            :name="name"
            v-model="proxyValue"
            label="name"
            :options="getOptions"
            :placeholder="t('Select')"
            :multiple="isMultiple"
            :clear-on-select="getClearOnSelect"
            :close-on-select="getCloseOnSelect"
        >
        </multiselect>
        <ul class="error-placeholder" v-if="isErrors">
            <li v-for="error in errors">{{ error }}</li>
        </ul>
    </div>
</template>

<script>

import Multiselect from '../Multiselect';
import ValueChecker from "../../services/ValueChecker";

export default {
    components: {Multiselect},
    props: {
        config: {
            type: Object,
            default: () => {return {};}
        },
        label: {
            Type: String,
        },
        name: {
            Type: String,
        },
        parentIndex: {
            Type: String,
        },
    },
    computed: {
        isErrors() {
            return this.errors.length > 0;
        },
        getOptions() {
            return ValueChecker.isUndefinedOrNull(this.config.availableValue) ? [] : this.config.availableValue;
        },
        getClearOnSelect() {
            return ValueChecker.isUndefinedOrNull(this.config.clearOnSelect) ? false : this.config.clearOnSelect;
        },
        getCloseOnSelect() {
            if (!this.isMultiple) {
                return true;
            }

            return ValueChecker.isUndefinedOrNull(this.config.closeOnSelect) ? false : this.config.closeOnSelect;
        },
        isMultiple() {
            return ValueChecker.isUndefinedOrNull(this.config.multiple) ? false : this.config.multiple;
        }
    },
    data() {
        return {
            errors: [],
            proxyValue: [],
        };
    },
    mounted() {
        this.mountEvents();
    },
    methods: {
        mountEvents() {
            let eventManagerService = this.$root.getEventManager();

            this.$root.$on('FormComponent:submit-errors', (errors) => {
                this.resetErrors();

                if (errors[this.name]) {
                    this.errors = errors[this.name];
                }
            });

            this.$root.$on('FormComponent:show-component', () => {
                this.resetErrors();
            });
        },
        resetErrors() {
            this.errors = [];
        },
        setValue(config, value) {
            let v = value[this.name];

            if (!this.isMultiple) {
                v = [v];
            }

            this.proxyValue = this.getOptions.filter(o => {
                return v.includes(o.id);
            });
        },
    },
    watch: {
        proxyValue: {
            handler: function (newData, oldData) {
                if (!this.isMultiple && !ValueChecker.isArray(newData)) {
                    newData = [newData];
                }

                this.$emit('input', newData.map(v => { return v.id}));
            }
        }
    }
}

</script>

<style>
    .error-placeholder {
        color: red;
        font-size: 0.9em;
    }
    .errors {
        border: 1px solid red;
    }
</style>


// WEBPACK FOOTER //
// SelectInput.vue?4f4c708a